import { jsx as C, jsxs as J } from "@emotion/react/jsx-runtime";
import { i as qe, a as wt, R as Rt, n as Gt, u as $e, G as Zt, M as Wt, I as Lt, S as Vt } from "./Header-d6011702.mjs";
import { H as Bo } from "./Header-d6011702.mjs";
import { Global as kt } from "@emotion/react";
import { AnalyticsProvider as Bt } from "@inflearn/analytics";
import { ThemeProvider as Xt, NotificationsProvider as _t, Modal as z, Text as Nt, Button as Tt } from "@inflearn/ds-react-next";
import { useQueryClient as Ht, onlineManager as Ne, notifyManager as Dt, QueryClient as Yt, QueryClientProvider as Ft } from "@tanstack/react-query";
import * as o from "react";
import et, { useMemo as Qt, useState as zt, useEffect as tt, cloneElement as Pt } from "react";
import { y as Mt, B as Jt, W as Ut, X as nt, Y as jt, Z as Kt, u as qt, _ as $t, $ as en, q as tn, w as nn, a0 as rn, a1 as on, a2 as an } from "./StickyHeaderSkeleton-812aba96.mjs";
import { g as ln, u as sn, i as Te, A as un } from "./onboardingData-5b29858a-8dc9d7cd.mjs";
import "@inflearn/ds-react-next/mantine-core-styles.css";
import "@inflearn/ds-react-next/mantine-notifications-styles.css";
import { s as cn } from "./styleSkeleton-ee4b319a.mjs";
import { i as dn } from "./quicklink-4fdae099.mjs";
import { createInstance as fn, HackleProvider as pn } from "@hackler/react-sdk";
import { ChannelTalk as mn } from "./Channeltalk-551911df.mjs";
import gn from "./MoveTop-e256c4b7.mjs";
import yn from "./BottomNavigation-fbe93016.mjs";
import { SideSheet as bn } from "./SideSheet-47542ee8.mjs";
import "react-error-boundary";
import "@inflearn/datasource-rest";
import "react/jsx-runtime";
import "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/locale/vi";
import "dayjs/locale/ja";
import "dayjs/plugin/localizedFormat";
import "dayjs/plugin/timezone";
import "dayjs/plugin/updateLocale";
import "dayjs/plugin/utc";
import "react-hook-form";
import "dayjs/plugin/duration";
import "dayjs/plugin/relativeTime";
function Q() {
  return Q = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Q.apply(this, arguments);
}
/**
   * match-sorter-utils
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
const rt = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z"
}, hn = Object.keys(rt).join("|"), vn = new RegExp(hn, "g");
function Cn(e) {
  return e.replace(vn, (t) => rt[t]);
}
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2099 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const L = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
function In(e, t, n) {
  var r;
  if (n = n || {}, n.threshold = (r = n.threshold) != null ? r : L.MATCHES, !n.accessors) {
    const i = He(e, t, n);
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: e,
      rank: i,
      accessorIndex: -1,
      accessorThreshold: n.threshold,
      passed: i >= n.threshold
    };
  }
  const a = xn(e, n.accessors), l = {
    rankedValue: e,
    rank: L.NO_MATCH,
    accessorIndex: -1,
    accessorThreshold: n.threshold,
    passed: !1
  };
  for (let i = 0; i < a.length; i++) {
    const s = a[i];
    let u = He(s.itemValue, t, n);
    const {
      minRanking: p,
      maxRanking: m,
      threshold: f = n.threshold
    } = s.attributes;
    u < p && u >= L.MATCHES ? u = p : u > m && (u = m), u = Math.min(u, m), u >= f && u > l.rank && (l.rank = u, l.passed = !0, l.accessorIndex = i, l.accessorThreshold = f, l.rankedValue = s.itemValue);
  }
  return l;
}
function He(e, t, n) {
  return e = De(e, n), t = De(t, n), t.length > e.length ? L.NO_MATCH : e === t ? L.CASE_SENSITIVE_EQUAL : (e = e.toLowerCase(), t = t.toLowerCase(), e === t ? L.EQUAL : e.startsWith(t) ? L.STARTS_WITH : e.includes(` ${t}`) ? L.WORD_STARTS_WITH : e.includes(t) ? L.CONTAINS : t.length === 1 ? L.NO_MATCH : En(e).includes(t) ? L.ACRONYM : An(e, t));
}
function En(e) {
  let t = "";
  return e.split(" ").forEach((r) => {
    r.split("-").forEach((l) => {
      t += l.substr(0, 1);
    });
  }), t;
}
function An(e, t) {
  let n = 0, r = 0;
  function a(u, p, m) {
    for (let f = m, g = p.length; f < g; f++)
      if (p[f] === u)
        return n += 1, f + 1;
    return -1;
  }
  function l(u) {
    const p = 1 / u, m = n / t.length;
    return L.MATCHES + m * p;
  }
  const i = a(t[0], e, 0);
  if (i < 0)
    return L.NO_MATCH;
  r = i;
  for (let u = 1, p = t.length; u < p; u++) {
    const m = t[u];
    if (r = a(m, e, r), !(r > -1))
      return L.NO_MATCH;
  }
  const s = r - i;
  return l(s);
}
function De(e, t) {
  let {
    keepDiacritics: n
  } = t;
  return e = `${e}`, n || (e = Cn(e)), e;
}
function Sn(e, t) {
  let n = t;
  typeof t == "object" && (n = t.accessor);
  const r = n(e);
  return r == null ? [] : Array.isArray(r) ? r : [String(r)];
}
function xn(e, t) {
  const n = [];
  for (let r = 0, a = t.length; r < a; r++) {
    const l = t[r], i = On(l), s = Sn(e, l);
    for (let u = 0, p = s.length; u < p; u++)
      n.push({
        itemValue: s[u],
        attributes: i
      });
  }
  return n;
}
const Ye = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function On(e) {
  return typeof e == "function" ? Ye : {
    ...Ye,
    ...e
  };
}
const wn = (e) => {
  try {
    const t = localStorage.getItem(e);
    return typeof t == "string" ? JSON.parse(t) : void 0;
  } catch {
    return;
  }
};
function P(e, t) {
  const [n, r] = o.useState();
  o.useEffect(() => {
    const l = wn(e);
    r(typeof l > "u" || l === null ? typeof t == "function" ? t() : t : l);
  }, [t, e]);
  const a = o.useCallback((l) => {
    r((i) => {
      let s = l;
      typeof l == "function" && (s = l(i));
      try {
        localStorage.setItem(e, JSON.stringify(s));
      } catch {
      }
      return s;
    });
  }, [e]);
  return [n, a];
}
var Rn = (
  /** @class */
  function() {
    function e() {
      this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
    }
    return e.prototype.set = function(t, n) {
      this.keyToValue.set(t, n), this.valueToKey.set(n, t);
    }, e.prototype.getByKey = function(t) {
      return this.keyToValue.get(t);
    }, e.prototype.getByValue = function(t) {
      return this.valueToKey.get(t);
    }, e.prototype.clear = function() {
      this.keyToValue.clear(), this.valueToKey.clear();
    }, e;
  }()
), ot = (
  /** @class */
  function() {
    function e(t) {
      this.generateIdentifier = t, this.kv = new Rn();
    }
    return e.prototype.register = function(t, n) {
      this.kv.getByValue(t) || (n || (n = this.generateIdentifier(t)), this.kv.set(n, t));
    }, e.prototype.clear = function() {
      this.kv.clear();
    }, e.prototype.getIdentifier = function(t) {
      return this.kv.getByValue(t);
    }, e.prototype.getValue = function(t) {
      return this.kv.getByKey(t);
    }, e;
  }()
), Gn = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, a) {
      r.__proto__ = a;
    } || function(r, a) {
      for (var l in a)
        Object.prototype.hasOwnProperty.call(a, l) && (r[l] = a[l]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Zn = (
  /** @class */
  function(e) {
    Gn(t, e);
    function t() {
      var n = e.call(this, function(r) {
        return r.name;
      }) || this;
      return n.classToAllowedProps = /* @__PURE__ */ new Map(), n;
    }
    return t.prototype.register = function(n, r) {
      typeof r == "object" ? (r.allowProps && this.classToAllowedProps.set(n, r.allowProps), e.prototype.register.call(this, n, r.identifier)) : e.prototype.register.call(this, n, r);
    }, t.prototype.getAllowedProps = function(n) {
      return this.classToAllowedProps.get(n);
    }, t;
  }(ot)
), Wn = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
};
function Ln(e) {
  if ("values" in Object)
    return Object.values(e);
  var t = [];
  for (var n in e)
    e.hasOwnProperty(n) && t.push(e[n]);
  return t;
}
function Vn(e, t) {
  var n = Ln(e);
  if ("find" in n)
    return n.find(t);
  for (var r = n, a = 0; a < r.length; a++) {
    var l = r[a];
    if (t(l))
      return l;
  }
}
function ne(e, t) {
  Object.entries(e).forEach(function(n) {
    var r = Wn(n, 2), a = r[0], l = r[1];
    return t(l, a);
  });
}
function ge(e, t) {
  return e.indexOf(t) !== -1;
}
function Fe(e, t) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    if (t(r))
      return r;
  }
}
var kn = (
  /** @class */
  function() {
    function e() {
      this.transfomers = {};
    }
    return e.prototype.register = function(t) {
      this.transfomers[t.name] = t;
    }, e.prototype.findApplicable = function(t) {
      return Vn(this.transfomers, function(n) {
        return n.isApplicable(t);
      });
    }, e.prototype.findByName = function(t) {
      return this.transfomers[t];
    }, e;
  }()
), Bn = function(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}, at = function(e) {
  return typeof e > "u";
}, Xn = function(e) {
  return e === null;
}, le = function(e) {
  return typeof e != "object" || e === null || e === Object.prototype ? !1 : Object.getPrototypeOf(e) === null ? !0 : Object.getPrototypeOf(e) === Object.prototype;
}, xe = function(e) {
  return le(e) && Object.keys(e).length === 0;
}, U = function(e) {
  return Array.isArray(e);
}, _n = function(e) {
  return typeof e == "string";
}, Nn = function(e) {
  return typeof e == "number" && !isNaN(e);
}, Tn = function(e) {
  return typeof e == "boolean";
}, Hn = function(e) {
  return e instanceof RegExp;
}, se = function(e) {
  return e instanceof Map;
}, ue = function(e) {
  return e instanceof Set;
}, it = function(e) {
  return Bn(e) === "Symbol";
}, Dn = function(e) {
  return e instanceof Date && !isNaN(e.valueOf());
}, Yn = function(e) {
  return e instanceof Error;
}, Qe = function(e) {
  return typeof e == "number" && isNaN(e);
}, Fn = function(e) {
  return Tn(e) || Xn(e) || at(e) || Nn(e) || _n(e) || it(e);
}, Qn = function(e) {
  return typeof e == "bigint";
}, zn = function(e) {
  return e === 1 / 0 || e === -1 / 0;
}, Pn = function(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}, Mn = function(e) {
  return e instanceof URL;
}, lt = function(e) {
  return e.replace(/\./g, "\\.");
}, Ce = function(e) {
  return e.map(String).map(lt).join(".");
}, ie = function(e) {
  for (var t = [], n = "", r = 0; r < e.length; r++) {
    var a = e.charAt(r), l = a === "\\" && e.charAt(r + 1) === ".";
    if (l) {
      n += ".", r++;
      continue;
    }
    var i = a === ".";
    if (i) {
      t.push(n), n = "";
      continue;
    }
    n += a;
  }
  var s = n;
  return t.push(s), t;
}, Oe = globalThis && globalThis.__assign || function() {
  return Oe = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Oe.apply(this, arguments);
}, we = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
}, Re = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, a = e.length; n < r; n++, a++)
    e[a] = t[n];
  return e;
};
function X(e, t, n, r) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: r
  };
}
var st = [
  X(at, "undefined", function() {
    return null;
  }, function() {
  }),
  X(Qn, "bigint", function(e) {
    return e.toString();
  }, function(e) {
    return typeof BigInt < "u" ? BigInt(e) : (console.error("Please add a BigInt polyfill."), e);
  }),
  X(Dn, "Date", function(e) {
    return e.toISOString();
  }, function(e) {
    return new Date(e);
  }),
  X(Yn, "Error", function(e, t) {
    var n = {
      name: e.name,
      message: e.message
    };
    return t.allowedErrorProps.forEach(function(r) {
      n[r] = e[r];
    }), n;
  }, function(e, t) {
    var n = new Error(e.message);
    return n.name = e.name, n.stack = e.stack, t.allowedErrorProps.forEach(function(r) {
      n[r] = e[r];
    }), n;
  }),
  X(Hn, "regexp", function(e) {
    return "" + e;
  }, function(e) {
    var t = e.slice(1, e.lastIndexOf("/")), n = e.slice(e.lastIndexOf("/") + 1);
    return new RegExp(t, n);
  }),
  X(
    ue,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    function(e) {
      return Re([], we(e.values()));
    },
    function(e) {
      return new Set(e);
    }
  ),
  X(se, "map", function(e) {
    return Re([], we(e.entries()));
  }, function(e) {
    return new Map(e);
  }),
  X(function(e) {
    return Qe(e) || zn(e);
  }, "number", function(e) {
    return Qe(e) ? "NaN" : e > 0 ? "Infinity" : "-Infinity";
  }, Number),
  X(function(e) {
    return e === 0 && 1 / e === -1 / 0;
  }, "number", function() {
    return "-0";
  }, Number),
  X(Mn, "URL", function(e) {
    return e.toString();
  }, function(e) {
    return new URL(e);
  })
];
function be(e, t, n, r) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: r
  };
}
var ut = be(function(e, t) {
  if (it(e)) {
    var n = !!t.symbolRegistry.getIdentifier(e);
    return n;
  }
  return !1;
}, function(e, t) {
  var n = t.symbolRegistry.getIdentifier(e);
  return ["symbol", n];
}, function(e) {
  return e.description;
}, function(e, t, n) {
  var r = n.symbolRegistry.getValue(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown symbol");
  return r;
}), Jn = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce(function(e, t) {
  return e[t.name] = t, e;
}, {}), ct = be(Pn, function(e) {
  return ["typed-array", e.constructor.name];
}, function(e) {
  return Re([], we(e));
}, function(e, t) {
  var n = Jn[t[1]];
  if (!n)
    throw new Error("Trying to deserialize unknown typed array");
  return new n(e);
});
function dt(e, t) {
  if (e != null && e.constructor) {
    var n = !!t.classRegistry.getIdentifier(e.constructor);
    return n;
  }
  return !1;
}
var ft = be(dt, function(e, t) {
  var n = t.classRegistry.getIdentifier(e.constructor);
  return ["class", n];
}, function(e, t) {
  var n = t.classRegistry.getAllowedProps(e.constructor);
  if (!n)
    return Oe({}, e);
  var r = {};
  return n.forEach(function(a) {
    r[a] = e[a];
  }), r;
}, function(e, t, n) {
  var r = n.classRegistry.getValue(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
  return Object.assign(Object.create(r.prototype), e);
}), pt = be(function(e, t) {
  return !!t.customTransformerRegistry.findApplicable(e);
}, function(e, t) {
  var n = t.customTransformerRegistry.findApplicable(e);
  return ["custom", n.name];
}, function(e, t) {
  var n = t.customTransformerRegistry.findApplicable(e);
  return n.serialize(e);
}, function(e, t, n) {
  var r = n.customTransformerRegistry.findByName(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown custom value");
  return r.deserialize(e);
}), Un = [ft, ut, pt, ct], ze = function(e, t) {
  var n = Fe(Un, function(a) {
    return a.isApplicable(e, t);
  });
  if (n)
    return {
      value: n.transform(e, t),
      type: n.annotation(e, t)
    };
  var r = Fe(st, function(a) {
    return a.isApplicable(e, t);
  });
  if (r)
    return {
      value: r.transform(e, t),
      type: r.annotation
    };
}, mt = {};
st.forEach(function(e) {
  mt[e.annotation] = e;
});
var jn = function(e, t, n) {
  if (U(t))
    switch (t[0]) {
      case "symbol":
        return ut.untransform(e, t, n);
      case "class":
        return ft.untransform(e, t, n);
      case "custom":
        return pt.untransform(e, t, n);
      case "typed-array":
        return ct.untransform(e, t, n);
      default:
        throw new Error("Unknown transformation: " + t);
    }
  else {
    var r = mt[t];
    if (!r)
      throw new Error("Unknown transformation: " + t);
    return r.untransform(e, n);
  }
}, te = function(e, t) {
  for (var n = e.keys(); t > 0; )
    n.next(), t--;
  return n.next().value;
};
function gt(e) {
  if (ge(e, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (ge(e, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (ge(e, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
var Kn = function(e, t) {
  gt(t);
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    if (ue(e))
      e = te(e, +r);
    else if (se(e)) {
      var a = +r, l = +t[++n] == 0 ? "key" : "value", i = te(e, a);
      switch (l) {
        case "key":
          e = i;
          break;
        case "value":
          e = e.get(i);
          break;
      }
    } else
      e = e[r];
  }
  return e;
}, Ge = function(e, t, n) {
  if (gt(t), t.length === 0)
    return n(e);
  for (var r = e, a = 0; a < t.length - 1; a++) {
    var l = t[a];
    if (U(r)) {
      var i = +l;
      r = r[i];
    } else if (le(r))
      r = r[l];
    else if (ue(r)) {
      var s = +l;
      r = te(r, s);
    } else if (se(r)) {
      var u = a === t.length - 2;
      if (u)
        break;
      var s = +l, p = +t[++a] == 0 ? "key" : "value", m = te(r, s);
      switch (p) {
        case "key":
          r = m;
          break;
        case "value":
          r = r.get(m);
          break;
      }
    }
  }
  var f = t[t.length - 1];
  if (U(r) ? r[+f] = n(r[+f]) : le(r) && (r[f] = n(r[f])), ue(r)) {
    var g = te(r, +f), c = n(g);
    g !== c && (r.delete(g), r.add(c));
  }
  if (se(r)) {
    var s = +t[t.length - 2], d = te(r, s), p = +f == 0 ? "key" : "value";
    switch (p) {
      case "key": {
        var y = n(d);
        r.set(y, r.get(d)), y !== d && r.delete(d);
        break;
      }
      case "value": {
        r.set(d, n(r.get(d)));
        break;
      }
    }
  }
  return e;
}, Y = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
}, M = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, a = e.length; n < r; n++, a++)
    e[a] = t[n];
  return e;
};
function Ze(e, t, n) {
  if (n === void 0 && (n = []), !!e) {
    if (!U(e)) {
      ne(e, function(i, s) {
        return Ze(i, t, M(M([], Y(n)), Y(ie(s))));
      });
      return;
    }
    var r = Y(e, 2), a = r[0], l = r[1];
    l && ne(l, function(i, s) {
      Ze(i, t, M(M([], Y(n)), Y(ie(s))));
    }), t(a, n);
  }
}
function qn(e, t, n) {
  return Ze(t, function(r, a) {
    e = Ge(e, a, function(l) {
      return jn(l, r, n);
    });
  }), e;
}
function $n(e, t) {
  function n(i, s) {
    var u = Kn(e, ie(s));
    i.map(ie).forEach(function(p) {
      e = Ge(e, p, function() {
        return u;
      });
    });
  }
  if (U(t)) {
    var r = Y(t, 2), a = r[0], l = r[1];
    a.forEach(function(i) {
      e = Ge(e, ie(i), function() {
        return e;
      });
    }), l && ne(l, n);
  } else
    ne(t, n);
  return e;
}
var er = function(e, t) {
  return le(e) || U(e) || se(e) || ue(e) || dt(e, t);
};
function tr(e, t, n) {
  var r = n.get(e);
  r ? r.push(t) : n.set(e, [t]);
}
function nr(e, t) {
  var n = {}, r = void 0;
  return e.forEach(function(a) {
    if (!(a.length <= 1)) {
      t || (a = a.map(function(u) {
        return u.map(String);
      }).sort(function(u, p) {
        return u.length - p.length;
      }));
      var l = Y(a), i = l[0], s = l.slice(1);
      i.length === 0 ? r = s.map(Ce) : n[Ce(i)] = s.map(Ce);
    }
  }), r ? xe(n) ? [r] : [r, n] : xe(n) ? void 0 : n;
}
var yt = function(e, t, n, r, a, l, i) {
  var s;
  a === void 0 && (a = []), l === void 0 && (l = []), i === void 0 && (i = /* @__PURE__ */ new Map());
  var u = Fn(e);
  if (!u) {
    tr(e, a, t);
    var p = i.get(e);
    if (p)
      return r ? {
        transformedValue: null
      } : p;
  }
  if (!er(e, n)) {
    var m = ze(e, n), f = m ? {
      transformedValue: m.value,
      annotations: [m.type]
    } : {
      transformedValue: e
    };
    return u || i.set(e, f), f;
  }
  if (ge(l, e))
    return {
      transformedValue: null
    };
  var g = ze(e, n), c = (s = g == null ? void 0 : g.value) !== null && s !== void 0 ? s : e, d = U(c) ? [] : {}, y = {};
  ne(c, function(w, x) {
    var v = yt(w, t, n, r, M(M([], Y(a)), [x]), M(M([], Y(l)), [e]), i);
    d[x] = v.transformedValue, U(v.annotations) ? y[x] = v.annotations : le(v.annotations) && ne(v.annotations, function(b, O) {
      y[lt(x) + "." + O] = b;
    });
  });
  var E = xe(y) ? {
    transformedValue: d,
    annotations: g ? [g.type] : void 0
  } : {
    transformedValue: d,
    annotations: g ? [g.type, y] : y
  };
  return u || i.set(e, E), E;
};
function bt(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Pe(e) {
  return bt(e) === "Array";
}
function rr(e) {
  if (bt(e) !== "Object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return !!t && t.constructor === Object && t === Object.prototype;
}
function or(e, t, n, r, a) {
  const l = {}.propertyIsEnumerable.call(r, t) ? "enumerable" : "nonenumerable";
  l === "enumerable" && (e[t] = n), a && l === "nonenumerable" && Object.defineProperty(e, t, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function We(e, t = {}) {
  if (Pe(e))
    return e.map((a) => We(a, t));
  if (!rr(e))
    return e;
  const n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertySymbols(e);
  return [...n, ...r].reduce((a, l) => {
    if (Pe(t.props) && !t.props.includes(l))
      return a;
    const i = e[l], s = We(i, t);
    return or(a, l, s, e, t.nonenumerable), a;
  }, {});
}
var K = globalThis && globalThis.__assign || function() {
  return K = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, K.apply(this, arguments);
}, ar = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
}, ir = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, a = e.length; n < r; n++, a++)
    e[a] = t[n];
  return e;
}, N = (
  /** @class */
  function() {
    function e(t) {
      var n = t === void 0 ? {} : t, r = n.dedupe, a = r === void 0 ? !1 : r;
      this.classRegistry = new Zn(), this.symbolRegistry = new ot(function(l) {
        var i;
        return (i = l.description) !== null && i !== void 0 ? i : "";
      }), this.customTransformerRegistry = new kn(), this.allowedErrorProps = [], this.dedupe = a;
    }
    return e.prototype.serialize = function(t) {
      var n = /* @__PURE__ */ new Map(), r = yt(t, n, this, this.dedupe), a = {
        json: r.transformedValue
      };
      r.annotations && (a.meta = K(K({}, a.meta), { values: r.annotations }));
      var l = nr(n, this.dedupe);
      return l && (a.meta = K(K({}, a.meta), { referentialEqualities: l })), a;
    }, e.prototype.deserialize = function(t) {
      var n = t.json, r = t.meta, a = We(n);
      return r != null && r.values && (a = qn(a, r.values, this)), r != null && r.referentialEqualities && (a = $n(a, r.referentialEqualities)), a;
    }, e.prototype.stringify = function(t) {
      return JSON.stringify(this.serialize(t));
    }, e.prototype.parse = function(t) {
      return this.deserialize(JSON.parse(t));
    }, e.prototype.registerClass = function(t, n) {
      this.classRegistry.register(t, n);
    }, e.prototype.registerSymbol = function(t, n) {
      this.symbolRegistry.register(t, n);
    }, e.prototype.registerCustom = function(t, n) {
      this.customTransformerRegistry.register(K({ name: n }, t));
    }, e.prototype.allowErrorProps = function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      (t = this.allowedErrorProps).push.apply(t, ir([], ar(n)));
    }, e.defaultInstance = new e(), e.serialize = e.defaultInstance.serialize.bind(e.defaultInstance), e.deserialize = e.defaultInstance.deserialize.bind(e.defaultInstance), e.stringify = e.defaultInstance.stringify.bind(e.defaultInstance), e.parse = e.defaultInstance.parse.bind(e.defaultInstance), e.registerClass = e.defaultInstance.registerClass.bind(e.defaultInstance), e.registerSymbol = e.defaultInstance.registerSymbol.bind(e.defaultInstance), e.registerCustom = e.defaultInstance.registerCustom.bind(e.defaultInstance), e.allowErrorProps = e.defaultInstance.allowErrorProps.bind(e.defaultInstance), e;
  }()
);
N.serialize;
N.deserialize;
N.stringify;
N.parse;
N.registerClass;
N.registerCustom;
N.registerSymbol;
N.allowErrorProps;
const h = {
  background: "#0b1521",
  backgroundAlt: "#132337",
  foreground: "white",
  gray: "#3f4e60",
  grayAlt: "#222e3e",
  inputBackgroundColor: "#fff",
  inputTextColor: "#000",
  success: "#00ab52",
  danger: "#ff0085",
  active: "#006bff",
  paused: "#8c49eb",
  warning: "#ffb200"
}, ht = /* @__PURE__ */ o.createContext(h);
function vt({
  theme: e,
  ...t
}) {
  return /* @__PURE__ */ o.createElement(ht.Provider, Q({
    value: e
  }, t));
}
function lr() {
  return o.useContext(ht);
}
function sr(e) {
  const [t, n] = o.useState(() => {
    if (typeof window < "u")
      return window.matchMedia(e).matches;
  });
  return o.useEffect(() => {
    if (typeof window < "u") {
      const r = window.matchMedia(e), a = ({
        matches: l
      }) => n(l);
      return r.addListener(a), () => {
        r.removeListener(a);
      };
    }
  }, [t, e, n]), t;
}
function Ct({
  queryState: e,
  observerCount: t,
  isStale: n,
  theme: r
}) {
  return e.fetchStatus === "fetching" ? r.active : t ? e.fetchStatus === "paused" ? r.paused : n ? r.warning : r.success : r.gray;
}
function ee(e) {
  return e.state.fetchStatus === "fetching" ? "fetching" : e.getObserversCount() ? e.state.fetchStatus === "paused" ? "paused" : e.isStale() ? "stale" : "fresh" : "inactive";
}
function W(e, t, n = {}) {
  return /* @__PURE__ */ o.forwardRef(({
    style: r,
    ...a
  }, l) => {
    const i = lr(), s = Object.entries(n).reduce((u, [p, m]) => sr(p) ? {
      ...u,
      ...typeof m == "function" ? m(a, i) : m
    } : u, {});
    return /* @__PURE__ */ o.createElement(e, {
      ...a,
      style: {
        ...typeof t == "function" ? t(a, i) : t,
        ...r,
        ...s
      },
      ref: l
    });
  });
}
function ur() {
  const e = o.useRef(!1), t = o.useCallback(() => e.current, []);
  return o.useEffect(() => (e.current = !0, () => {
    e.current = !1;
  }), []), t;
}
const It = (e, t = !1) => {
  const {
    json: n
  } = N.serialize(e);
  return JSON.stringify(n, null, t ? 2 : void 0);
}, me = (e) => e.state.fetchStatus !== "idle" ? 0 : e.getObserversCount() ? e.isStale() ? 2 : 1 : 3, cr = (e, t) => e.queryHash.localeCompare(t.queryHash), Et = (e, t) => e.state.dataUpdatedAt < t.state.dataUpdatedAt ? 1 : -1, dr = (e, t) => me(e) === me(t) ? Et(e, t) : me(e) > me(t) ? 1 : -1, Ie = {
  "Status > Last Updated": dr,
  "Query Hash": cr,
  "Last Updated": Et
}, Le = 70, ce = 500, fr = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
function ye(e) {
  return ["left", "right"].includes(e);
}
function At(e) {
  return fr[e];
}
function _e(e, t) {
  return "" + e + (t.charAt(0).toUpperCase() + t.slice(1));
}
function pr({
  position: e = "bottom",
  height: t,
  width: n,
  devtoolsTheme: r,
  isOpen: a,
  isResizing: l,
  panelStyle: i
}) {
  const s = At(e), u = _e("border", s), p = ye(e);
  return {
    ...i,
    direction: "ltr",
    position: "fixed",
    [e]: 0,
    [u]: "1px solid " + r.gray,
    transformOrigin: s,
    boxShadow: "0 0 20px rgba(0,0,0,.3)",
    zIndex: 99999,
    // visibility will be toggled after transitions, but set initial state here
    visibility: a ? "visible" : "hidden",
    ...l ? {
      transition: "none"
    } : {
      transition: "all .2s ease"
    },
    ...a ? {
      opacity: 1,
      pointerEvents: "all",
      transform: p ? "translateX(0) scale(1)" : "translateY(0) scale(1)"
    } : {
      opacity: 0,
      pointerEvents: "none",
      transform: p ? "translateX(15px) scale(1.02)" : "translateY(15px) scale(1.02)"
    },
    ...p ? {
      top: 0,
      height: "100vh",
      maxWidth: "90%",
      width: typeof n == "number" && n >= Le ? n : ce
    } : {
      left: 0,
      width: "100%",
      maxHeight: "90%",
      height: typeof t == "number" && t >= Le ? t : ce
    }
  };
}
function mr(e = "bottom") {
  const t = ye(e), n = At(e), r = _e("margin", n);
  return {
    position: "absolute",
    cursor: t ? "col-resize" : "row-resize",
    zIndex: 1e5,
    [n]: 0,
    [r]: "-4px",
    ...t ? {
      top: 0,
      height: "100%",
      width: "4px"
    } : {
      width: "100%",
      height: "4px"
    }
  };
}
const gr = W("div", (e, t) => ({
  fontSize: "clamp(12px, 1.5vw, 14px)",
  fontFamily: "sans-serif",
  display: "flex",
  backgroundColor: t.background,
  color: t.foreground
}), {
  "(max-width: 700px)": {
    flexDirection: "column"
  },
  "(max-width: 600px)": {
    fontSize: ".9em"
    // flexDirection: 'column',
  }
}), yr = W("div", () => ({
  flex: "1 1 500px",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  height: "100%"
}), {
  "(max-width: 700px)": (e, t) => ({
    borderTop: "2px solid " + t.gray
  })
}), _ = W("button", (e, t) => ({
  appearance: "none",
  fontSize: ".9em",
  fontWeight: "bold",
  background: t.gray,
  border: "0",
  borderRadius: ".3em",
  color: "white",
  padding: ".5em",
  opacity: e.disabled ? ".5" : void 0,
  cursor: "pointer"
})), br = W("span", {
  display: "flex",
  flexWrap: "wrap",
  gap: "0.5em",
  fontSize: "0.9em"
}), ae = W("span", {
  display: "inline-flex",
  alignItems: "center",
  padding: ".2em .4em",
  fontWeight: "bold",
  textShadow: "0 0 10px black",
  borderRadius: ".2em"
}), F = W("code", {
  fontSize: ".9em",
  color: "inherit",
  background: "inherit"
}), hr = W("input", (e, t) => ({
  backgroundColor: t.inputBackgroundColor,
  border: 0,
  borderRadius: ".2em",
  color: t.inputTextColor,
  fontSize: ".9em",
  lineHeight: "1.3",
  padding: ".3em .4em"
})), Ve = W("select", (e, t) => ({
  display: "inline-block",
  fontSize: ".9em",
  fontFamily: "sans-serif",
  fontWeight: "normal",
  lineHeight: "1.3",
  padding: ".3em 1.5em .3em .5em",
  height: "auto",
  border: 0,
  borderRadius: ".2em",
  appearance: "none",
  WebkitAppearance: "none",
  backgroundColor: t.inputBackgroundColor,
  backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='%23444444'><polygon points='0,25 100,25 50,75'/></svg>")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right .55em center",
  backgroundSize: ".65em auto, 100%",
  color: t.inputTextColor
}), {
  "(max-width: 500px)": {
    display: "none"
  }
});
function ke({
  text: e
}) {
  return /* @__PURE__ */ o.createElement("span", {
    style: {
      position: "absolute",
      width: "0.1px",
      height: "0.1px",
      overflow: "hidden"
    }
  }, e);
}
const Me = W("div", {
  fontFamily: "Menlo, monospace",
  fontSize: "1em",
  lineHeight: "1.7",
  outline: "none",
  wordBreak: "break-word"
}), vr = W("span", {
  color: "white"
}), Cr = W("button", {
  cursor: "pointer",
  color: "white"
}), Ir = W("button", {
  cursor: "pointer",
  color: "inherit",
  font: "inherit",
  outline: "inherit",
  background: "transparent",
  border: "none",
  padding: 0
}), Er = ({
  value: e
}) => {
  const [t, n] = o.useState("NoCopy");
  return /* @__PURE__ */ o.createElement("button", {
    onClick: t === "NoCopy" ? () => {
      navigator.clipboard.writeText(N.stringify(e)).then(() => {
        n("SuccessCopy"), setTimeout(() => {
          n("NoCopy");
        }, 1500);
      }, (r) => {
        console.error("Failed to copy: ", r), n("ErrorCopy"), setTimeout(() => {
          n("NoCopy");
        }, 1500);
      });
    } : void 0,
    style: {
      cursor: "pointer",
      color: "inherit",
      font: "inherit",
      outline: "inherit",
      background: "transparent",
      border: "none",
      padding: 0
    }
  }, t === "NoCopy" ? /* @__PURE__ */ o.createElement(xr, null) : t === "SuccessCopy" ? /* @__PURE__ */ o.createElement(wr, null) : /* @__PURE__ */ o.createElement(Or, null));
}, Ar = W("span", (e, t) => ({
  color: t.danger
})), Ee = W("div", {
  marginLeft: ".1em",
  paddingLeft: "1em",
  borderLeft: "2px solid rgba(0,0,0,.15)"
}), Sr = W("span", {
  color: "grey",
  fontSize: ".7em"
}), Je = ({
  expanded: e,
  style: t = {}
}) => /* @__PURE__ */ o.createElement("span", {
  style: {
    display: "inline-block",
    transition: "all .1s ease",
    transform: "rotate(" + (e ? 90 : 0) + "deg) " + (t.transform || ""),
    ...t
  }
}, "▶"), xr = () => /* @__PURE__ */ o.createElement("span", {
  "aria-label": "Copy object to clipboard",
  title: "Copy object to clipboard",
  style: {
    paddingLeft: "1em"
  }
}, /* @__PURE__ */ o.createElement("svg", {
  height: "12",
  viewBox: "0 0 16 12",
  width: "10"
}, /* @__PURE__ */ o.createElement("path", {
  fill: "currentColor",
  d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"
}), /* @__PURE__ */ o.createElement("path", {
  fill: "currentColor",
  d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z"
}))), Or = () => /* @__PURE__ */ o.createElement("span", {
  "aria-label": "Failed copying to clipboard",
  title: "Failed copying to clipboard",
  style: {
    paddingLeft: "1em",
    display: "flex",
    alignItems: "center"
  }
}, /* @__PURE__ */ o.createElement("svg", {
  height: "12",
  viewBox: "0 0 16 12",
  width: "10",
  display: "block"
}, /* @__PURE__ */ o.createElement("path", {
  fill: "red",
  d: "M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z"
})), /* @__PURE__ */ o.createElement("span", {
  style: {
    color: "red",
    fontSize: "12px",
    paddingLeft: "4px",
    position: "relative",
    top: "2px"
  }
}, "See console")), wr = () => /* @__PURE__ */ o.createElement("span", {
  "aria-label": "Object copied to clipboard",
  title: "Object copied to clipboard",
  style: {
    paddingLeft: "1em",
    display: "inline-block",
    verticalAlign: "middle"
  }
}, /* @__PURE__ */ o.createElement("svg", {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  display: "block"
}, /* @__PURE__ */ o.createElement("path", {
  fill: "green",
  d: "M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"
})));
function Rr(e, t) {
  if (t < 1)
    return [];
  let n = 0;
  const r = [];
  for (; n < e.length; )
    r.push(e.slice(n, n + t)), n = n + t;
  return r;
}
const Gr = ({
  handleEntry: e,
  label: t,
  value: n,
  subEntries: r = [],
  subEntryPages: a = [],
  type: l,
  expanded: i = !1,
  copyable: s = !1,
  toggleExpanded: u,
  pageSize: p
}) => {
  const [m, f] = o.useState([]);
  return /* @__PURE__ */ o.createElement(Me, {
    key: t
  }, a.length ? /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(Ir, {
    onClick: () => u()
  }, /* @__PURE__ */ o.createElement(Je, {
    expanded: i
  }), " ", t, " ", /* @__PURE__ */ o.createElement(Sr, null, String(l).toLowerCase() === "iterable" ? "(Iterable) " : "", r.length, " ", r.length > 1 ? "items" : "item")), s ? /* @__PURE__ */ o.createElement(Er, {
    value: n
  }) : null, i ? a.length === 1 ? /* @__PURE__ */ o.createElement(Ee, null, r.map(e)) : /* @__PURE__ */ o.createElement(Ee, null, a.map((g, c) => /* @__PURE__ */ o.createElement("div", {
    key: c
  }, /* @__PURE__ */ o.createElement(Me, null, /* @__PURE__ */ o.createElement(Cr, {
    onClick: () => f((d) => d.includes(c) ? d.filter((y) => y !== c) : [...d, c])
  }, /* @__PURE__ */ o.createElement(Je, {
    expanded: i
  }), " [", c * p, " ...", " ", c * p + p - 1, "]"), m.includes(c) ? /* @__PURE__ */ o.createElement(Ee, null, g.map(e)) : null)))) : null) : /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(vr, null, t, ":"), " ", /* @__PURE__ */ o.createElement(Ar, null, It(n))));
};
function Zr(e) {
  return Symbol.iterator in e;
}
function Be({
  value: e,
  defaultExpanded: t,
  renderer: n = Gr,
  pageSize: r = 100,
  copyable: a = !1,
  ...l
}) {
  const [i, s] = o.useState(!!t), u = o.useCallback(() => s((c) => !c), []);
  let p = typeof e, m = [];
  const f = (c) => {
    const d = t === !0 ? {
      [c.label]: !0
    } : t == null ? void 0 : t[c.label];
    return {
      ...c,
      defaultExpanded: d
    };
  };
  Array.isArray(e) ? (p = "array", m = e.map((c, d) => f({
    label: d.toString(),
    value: c
  }))) : e !== null && typeof e == "object" && Zr(e) && typeof e[Symbol.iterator] == "function" ? (p = "Iterable", m = Array.from(e, (c, d) => f({
    label: d.toString(),
    value: c
  }))) : typeof e == "object" && e !== null && (p = "object", m = Object.entries(e).map(([c, d]) => f({
    label: c,
    value: d
  })));
  const g = Rr(m, r);
  return n({
    handleEntry: (c) => /* @__PURE__ */ o.createElement(Be, Q({
      key: c.label,
      value: e,
      renderer: n,
      copyable: a
    }, l, c)),
    type: p,
    subEntries: m,
    subEntryPages: g,
    value: e,
    expanded: i,
    copyable: a,
    toggleExpanded: u,
    pageSize: r,
    ...l
  });
}
function St(e) {
  return /* @__PURE__ */ o.createElement("svg", Q({
    width: "40px",
    height: "40px",
    viewBox: "0 0 190 190",
    version: "1.1"
  }, e), /* @__PURE__ */ o.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ o.createElement("g", {
    transform: "translate(-33.000000, 0.000000)"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M72.7239712,61.3436237 C69.631224,46.362877 68.9675112,34.8727722 70.9666331,26.5293551 C72.1555965,21.5671678 74.3293088,17.5190846 77.6346064,14.5984631 C81.1241394,11.5150478 85.5360327,10.0020122 90.493257,10.0020122 C98.6712013,10.0020122 107.26826,13.7273214 116.455725,20.8044264 C120.20312,23.6910458 124.092437,27.170411 128.131651,31.2444746 C128.45314,30.8310265 128.816542,30.4410453 129.22143,30.0806152 C140.64098,19.9149716 150.255245,13.5989272 158.478408,11.1636507 C163.367899,9.715636 167.958526,9.57768202 172.138936,10.983031 C176.551631,12.4664684 180.06766,15.5329489 182.548314,19.8281091 C186.642288,26.9166735 187.721918,36.2310983 186.195595,47.7320243 C185.573451,52.4199112 184.50985,57.5263831 183.007094,63.0593153 C183.574045,63.1277086 184.142416,63.2532808 184.705041,63.4395297 C199.193932,68.2358678 209.453582,73.3937462 215.665021,79.2882839 C219.360669,82.7953831 221.773972,86.6998434 222.646365,91.0218204 C223.567176,95.5836746 222.669313,100.159332 220.191548,104.451297 C216.105211,111.529614 208.591643,117.11221 197.887587,121.534031 C193.589552,123.309539 188.726579,124.917559 183.293259,126.363748 C183.541176,126.92292 183.733521,127.516759 183.862138,128.139758 C186.954886,143.120505 187.618598,154.61061 185.619477,162.954027 C184.430513,167.916214 182.256801,171.964297 178.951503,174.884919 C175.46197,177.968334 171.050077,179.48137 166.092853,179.48137 C157.914908,179.48137 149.31785,175.756061 140.130385,168.678956 C136.343104,165.761613 132.410866,162.238839 128.325434,158.108619 C127.905075,158.765474 127.388968,159.376011 126.77857,159.919385 C115.35902,170.085028 105.744755,176.401073 97.5215915,178.836349 C92.6321009,180.284364 88.0414736,180.422318 83.8610636,179.016969 C79.4483686,177.533532 75.9323404,174.467051 73.4516862,170.171891 C69.3577116,163.083327 68.2780823,153.768902 69.8044053,142.267976 C70.449038,137.410634 71.56762,132.103898 73.1575891,126.339009 C72.5361041,126.276104 71.9120754,126.144816 71.2949591,125.940529 C56.8060684,121.144191 46.5464184,115.986312 40.3349789,110.091775 C36.6393312,106.584675 34.2260275,102.680215 33.3536352,98.3582381 C32.4328237,93.7963839 33.3306866,89.2207269 35.8084524,84.9287618 C39.8947886,77.8504443 47.4083565,72.2678481 58.1124133,67.8460273 C62.5385143,66.0176154 67.5637208,64.366822 73.1939394,62.8874674 C72.9933393,62.3969171 72.8349374,61.8811235 72.7239712,61.3436237 Z",
    fill: "#002C4B",
    fillRule: "nonzero",
    transform: "translate(128.000000, 95.000000) scale(-1, 1) translate(-128.000000, -95.000000) "
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M113.396882,64 L142.608177,64 C144.399254,64 146.053521,64.958025 146.944933,66.5115174 L161.577138,92.0115174 C162.461464,93.5526583 162.461464,95.4473417 161.577138,96.9884826 L146.944933,122.488483 C146.053521,124.041975 144.399254,125 142.608177,125 L113.396882,125 C111.605806,125 109.951539,124.041975 109.060126,122.488483 L94.4279211,96.9884826 C93.543596,95.4473417 93.543596,93.5526583 94.4279211,92.0115174 L109.060126,66.5115174 C109.951539,64.958025 111.605806,64 113.396882,64 Z M138.987827,70.2765273 C140.779849,70.2765273 142.434839,71.2355558 143.325899,72.7903404 L154.343038,92.0138131 C155.225607,93.5537825 155.225607,95.4462175 154.343038,96.9861869 L143.325899,116.20966 C142.434839,117.764444 140.779849,118.723473 138.987827,118.723473 L117.017233,118.723473 C115.225211,118.723473 113.570221,117.764444 112.67916,116.20966 L101.662022,96.9861869 C100.779452,95.4462175 100.779452,93.5537825 101.662022,92.0138131 L112.67916,72.7903404 C113.570221,71.2355558 115.225211,70.2765273 117.017233,70.2765273 L138.987827,70.2765273 Z M135.080648,77.1414791 L120.924411,77.1414791 C119.134228,77.1414791 117.480644,78.0985567 116.5889,79.6508285 L116.5889,79.6508285 L109.489217,92.0093494 C108.603232,93.5515958 108.603232,95.4484042 109.489217,96.9906506 L109.489217,96.9906506 L116.5889,109.349172 C117.480644,110.901443 119.134228,111.858521 120.924411,111.858521 L120.924411,111.858521 L135.080648,111.858521 C136.870831,111.858521 138.524416,110.901443 139.41616,109.349172 L139.41616,109.349172 L146.515843,96.9906506 C147.401828,95.4484042 147.401828,93.5515958 146.515843,92.0093494 L146.515843,92.0093494 L139.41616,79.6508285 C138.524416,78.0985567 136.870831,77.1414791 135.080648,77.1414791 L135.080648,77.1414791 Z M131.319186,83.7122186 C133.108028,83.7122186 134.760587,84.6678753 135.652827,86.2183156 L138.983552,92.0060969 C139.87203,93.5500005 139.87203,95.4499995 138.983552,96.9939031 L135.652827,102.781684 C134.760587,104.332125 133.108028,105.287781 131.319186,105.287781 L124.685874,105.287781 C122.897032,105.287781 121.244473,104.332125 120.352233,102.781684 L117.021508,96.9939031 C116.13303,95.4499995 116.13303,93.5500005 117.021508,92.0060969 L120.352233,86.2183156 C121.244473,84.6678753 122.897032,83.7122186 124.685874,83.7122186 L131.319186,83.7122186 Z M128.003794,90.1848875 C126.459294,90.1848875 125.034382,91.0072828 124.263005,92.3424437 C123.491732,93.6774232 123.491732,95.3225768 124.263005,96.6575563 C125.034382,97.9927172 126.459294,98.8151125 128.001266,98.8151125 L128.001266,98.8151125 C129.545766,98.8151125 130.970678,97.9927172 131.742055,96.6575563 C132.513327,95.3225768 132.513327,93.6774232 131.742055,92.3424437 C130.970678,91.0072828 129.545766,90.1848875 128.003794,90.1848875 L128.003794,90.1848875 Z M93,94.5009646 L100.767764,94.5009646",
    fill: "#FFD94C"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M87.8601729,108.357758 C89.1715224,107.608286 90.8360246,108.074601 91.5779424,109.399303 L91.5779424,109.399303 L92.0525843,110.24352 C95.8563392,116.982993 99.8190116,123.380176 103.940602,129.435068 C108.807881,136.585427 114.28184,143.82411 120.362479,151.151115 C121.316878,152.30114 121.184944,154.011176 120.065686,154.997937 L120.065686,154.997937 L119.454208,155.534625 C99.3465389,173.103314 86.2778188,176.612552 80.2480482,166.062341 C74.3500652,155.742717 76.4844915,136.982888 86.6513274,109.782853 C86.876818,109.179582 87.3045861,108.675291 87.8601729,108.357758 Z M173.534177,129.041504 C174.986131,128.785177 176.375496,129.742138 176.65963,131.194242 L176.65963,131.194242 L176.812815,131.986376 C181.782365,157.995459 178.283348,171 166.315764,171 C154.609745,171 139.708724,159.909007 121.612702,137.727022 C121.211349,137.235047 120.994572,136.617371 121,135.981509 C121.013158,134.480686 122.235785,133.274651 123.730918,133.287756 L123.730918,133.287756 L124.684654,133.294531 C132.305698,133.335994 139.714387,133.071591 146.910723,132.501323 C155.409039,131.82788 164.283523,130.674607 173.534177,129.041504 Z M180.408726,73.8119663 C180.932139,72.4026903 182.508386,71.6634537 183.954581,72.149012 L183.954581,72.149012 L184.742552,72.4154854 C210.583763,81.217922 220.402356,90.8916805 214.198332,101.436761 C208.129904,111.751366 190.484347,119.260339 161.26166,123.963678 C160.613529,124.067994 159.948643,123.945969 159.382735,123.618843 C158.047025,122.846729 157.602046,121.158214 158.388848,119.847438 L158.388848,119.847438 L158.889328,119.0105 C162.877183,112.31633 166.481358,105.654262 169.701854,99.0242957 C173.50501,91.1948179 177.073967,82.7907081 180.408726,73.8119663 Z M94.7383398,66.0363218 C95.3864708,65.9320063 96.0513565,66.0540315 96.6172646,66.3811573 C97.9529754,67.153271 98.3979538,68.8417862 97.6111517,70.1525615 L97.6111517,70.1525615 L97.1106718,70.9895001 C93.1228168,77.6836699 89.5186416,84.3457379 86.2981462,90.9757043 C82.49499,98.8051821 78.9260328,107.209292 75.5912744,116.188034 C75.0678608,117.59731 73.4916142,118.336546 72.045419,117.850988 L72.045419,117.850988 L71.2574475,117.584515 C45.4162372,108.782078 35.597644,99.1083195 41.8016679,88.5632391 C47.8700957,78.2486335 65.515653,70.7396611 94.7383398,66.0363218 Z M136.545792,34.4653746 C156.653461,16.8966864 169.722181,13.3874478 175.751952,23.9376587 C181.649935,34.2572826 179.515508,53.0171122 169.348673,80.2171474 C169.123182,80.8204179 168.695414,81.324709 168.139827,81.6422422 C166.828478,82.3917144 165.163975,81.9253986 164.422058,80.6006966 L164.422058,80.6006966 L163.947416,79.7564798 C160.143661,73.0170065 156.180988,66.6198239 152.059398,60.564932 C147.192119,53.4145727 141.71816,46.1758903 135.637521,38.8488847 C134.683122,37.6988602 134.815056,35.9888243 135.934314,35.0020629 L135.934314,35.0020629 Z M90.6842361,18 C102.390255,18 117.291276,29.0909926 135.387298,51.2729777 C135.788651,51.7649527 136.005428,52.3826288 136,53.0184911 C135.986842,54.5193144 134.764215,55.7253489 133.269082,55.7122445 L133.269082,55.7122445 L132.315346,55.7054689 C124.694302,55.6640063 117.285613,55.9284091 110.089277,56.4986773 C101.590961,57.17212 92.7164767,58.325393 83.4658235,59.9584962 C82.0138691,60.2148231 80.6245044,59.2578618 80.3403697,57.805758 L80.3403697,57.805758 L80.1871846,57.0136235 C75.2176347,31.0045412 78.7166519,18 90.6842361,18 Z",
    fill: "#FF4154"
  }))));
}
var Xe = { exports: {} }, Ae = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ue;
function Wr() {
  if (Ue)
    return Ae;
  Ue = 1;
  var e = et;
  function t(f, g) {
    return f === g && (f !== 0 || 1 / f === 1 / g) || f !== f && g !== g;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, a = e.useEffect, l = e.useLayoutEffect, i = e.useDebugValue;
  function s(f, g) {
    var c = g(), d = r({ inst: { value: c, getSnapshot: g } }), y = d[0].inst, E = d[1];
    return l(function() {
      y.value = c, y.getSnapshot = g, u(y) && E({ inst: y });
    }, [f, c, g]), a(function() {
      return u(y) && E({ inst: y }), f(function() {
        u(y) && E({ inst: y });
      });
    }, [f]), i(c), c;
  }
  function u(f) {
    var g = f.getSnapshot;
    f = f.value;
    try {
      var c = g();
      return !n(f, c);
    } catch {
      return !0;
    }
  }
  function p(f, g) {
    return g();
  }
  var m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : s;
  return Ae.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : m, Ae;
}
var Se = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var je;
function Lr() {
  return je || (je = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = et, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(v) {
      {
        for (var b = arguments.length, O = new Array(b > 1 ? b - 1 : 0), A = 1; A < b; A++)
          O[A - 1] = arguments[A];
        r("error", v, O);
      }
    }
    function r(v, b, O) {
      {
        var A = t.ReactDebugCurrentFrame, k = A.getStackAddendum();
        k !== "" && (b += "%s", O = O.concat([k]));
        var V = O.map(function(G) {
          return String(G);
        });
        V.unshift("Warning: " + b), Function.prototype.apply.call(console[v], console, V);
      }
    }
    function a(v, b) {
      return v === b && (v !== 0 || 1 / v === 1 / b) || v !== v && b !== b;
    }
    var l = typeof Object.is == "function" ? Object.is : a, i = e.useState, s = e.useEffect, u = e.useLayoutEffect, p = e.useDebugValue, m = !1, f = !1;
    function g(v, b, O) {
      m || e.startTransition !== void 0 && (m = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var A = b();
      if (!f) {
        var k = b();
        l(A, k) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var V = i({
        inst: {
          value: A,
          getSnapshot: b
        }
      }), G = V[0].inst, T = V[1];
      return u(function() {
        G.value = A, G.getSnapshot = b, c(G) && T({
          inst: G
        });
      }, [v, A, b]), s(function() {
        c(G) && T({
          inst: G
        });
        var re = function() {
          c(G) && T({
            inst: G
          });
        };
        return v(re);
      }, [v]), p(A), A;
    }
    function c(v) {
      var b = v.getSnapshot, O = v.value;
      try {
        var A = b();
        return !l(O, A);
      } catch {
        return !0;
      }
    }
    function d(v, b, O) {
      return b();
    }
    var y = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", E = !y, w = E ? d : g, x = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : w;
    Se.useSyncExternalStore = x, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Se;
}
process.env.NODE_ENV === "production" ? Xe.exports = Wr() : Xe.exports = Lr();
var Vr = Xe.exports;
function kr({
  initialIsOpen: e,
  panelProps: t = {},
  closeButtonProps: n = {},
  toggleButtonProps: r = {},
  position: a = "bottom-left",
  containerElement: l = "aside",
  context: i,
  styleNonce: s,
  panelPosition: u = "bottom",
  errorTypes: p = []
}) {
  const m = o.useRef(null), f = o.useRef(null), [g, c] = P("reactQueryDevtoolsOpen", e), [d, y] = P("reactQueryDevtoolsHeight", ce), [E, w] = P("reactQueryDevtoolsWidth", ce), [x = "bottom", v] = P("reactQueryDevtoolsPanelPosition", u), [b, O] = o.useState(!1), [A, k] = o.useState(!1), V = ur(), G = (S, R) => {
    if (!S || R.button !== 0)
      return;
    const B = ye(x);
    k(!0);
    const {
      height: oe,
      width: ve
    } = S.getBoundingClientRect(), q = R.clientX, $ = R.clientY;
    let D = 0;
    const fe = (j) => {
      j.preventDefault(), B ? (D = ve + (x === "right" ? q - j.clientX : j.clientX - q), w(D)) : (D = oe + (x === "bottom" ? $ - j.clientY : j.clientY - $), y(D)), D < Le ? c(!1) : c(!0);
    }, pe = () => {
      A && k(!1), document.removeEventListener("mousemove", fe, !1), document.removeEventListener("mouseUp", pe, !1);
    };
    document.addEventListener("mousemove", fe, !1), document.addEventListener("mouseup", pe, !1);
  };
  o.useEffect(() => {
    O(g ?? !1);
  }, [g, b, O]), o.useEffect(() => {
    const S = f.current;
    if (S) {
      const R = () => {
        b && (S.style.visibility = "visible");
      }, B = () => {
        b || (S.style.visibility = "hidden");
      };
      return S.addEventListener("transitionstart", R), S.addEventListener("transitionend", B), () => {
        S.removeEventListener("transitionstart", R), S.removeEventListener("transitionend", B);
      };
    }
  }, [b]), o.useEffect(() => {
    var S;
    if (b && (S = m.current) != null && S.parentElement) {
      const {
        parentElement: R
      } = m.current, B = _e("padding", x), oe = ye(x), ve = (({
        padding: $,
        paddingTop: D,
        paddingBottom: fe,
        paddingLeft: pe,
        paddingRight: j
      }) => ({
        padding: $,
        paddingTop: D,
        paddingBottom: fe,
        paddingLeft: pe,
        paddingRight: j
      }))(R.style), q = () => {
        R.style.padding = "0px", R.style.paddingTop = "0px", R.style.paddingBottom = "0px", R.style.paddingLeft = "0px", R.style.paddingRight = "0px", R.style[B] = (oe ? E : d) + "px";
      };
      if (q(), typeof window < "u")
        return window.addEventListener("resize", q), () => {
          window.removeEventListener("resize", q), Object.entries(ve).forEach(([$, D]) => {
            R.style[$] = D;
          });
        };
    }
  }, [b, x, d, E]);
  const {
    style: T = {},
    ...re
  } = t, {
    style: he = {},
    onClick: H,
    ...de
  } = r, I = pr({
    position: x,
    devtoolsTheme: h,
    isOpen: b,
    height: d,
    width: E,
    isResizing: A,
    panelStyle: T
  });
  return V() ? /* @__PURE__ */ o.createElement(l, {
    ref: m,
    className: "ReactQueryDevtools",
    "aria-label": "React Query Devtools"
  }, /* @__PURE__ */ o.createElement(vt, {
    theme: h
  }, /* @__PURE__ */ o.createElement(xt, Q({
    ref: f,
    context: i,
    styleNonce: s,
    position: x,
    onPositionChange: v,
    showCloseButton: !0,
    closeButtonProps: n
  }, re, {
    style: I,
    isOpen: b,
    setIsOpen: c,
    onDragStart: (S) => G(f.current, S),
    errorTypes: p
  }))), b ? null : /* @__PURE__ */ o.createElement("button", Q({
    type: "button"
  }, de, {
    "aria-label": "Open React Query Devtools",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "false",
    onClick: (S) => {
      c(!0), H == null || H(S);
    },
    style: {
      background: "none",
      border: 0,
      padding: 0,
      position: "fixed",
      zIndex: 99999,
      display: "inline-flex",
      fontSize: "1.5em",
      margin: ".5em",
      cursor: "pointer",
      width: "fit-content",
      ...a === "top-right" ? {
        top: "0",
        right: "0"
      } : a === "top-left" ? {
        top: "0",
        left: "0"
      } : a === "bottom-right" ? {
        bottom: "0",
        right: "0"
      } : {
        bottom: "0",
        left: "0"
      },
      ...he
    }
  }), /* @__PURE__ */ o.createElement(St, {
    "aria-hidden": !0
  }), /* @__PURE__ */ o.createElement(ke, {
    text: "Open React Query Devtools"
  }))) : null;
}
const Z = (e, t, n = !1) => Vr.useSyncExternalStore(o.useCallback((r) => n ? () => {
} : e.subscribe(Dt.batchCalls(r)), [e, n]), t, t), xt = /* @__PURE__ */ o.forwardRef(function(t, n) {
  const {
    isOpen: r = !0,
    styleNonce: a,
    setIsOpen: l,
    context: i,
    onDragStart: s,
    onPositionChange: u,
    showCloseButton: p,
    position: m,
    closeButtonProps: f = {},
    errorTypes: g = [],
    ...c
  } = t, {
    onClick: d,
    ...y
  } = f, E = Ht({
    context: i
  }), w = E.getQueryCache(), [x, v] = P("reactQueryDevtoolsSortFn", Object.keys(Ie)[0]), [b, O] = P("reactQueryDevtoolsFilter", ""), [A, k] = P("reactQueryDevtoolsBaseSort", 1), V = o.useMemo(() => Ie[x], [x]), G = Z(w, () => w.getAll().length, !r), [T, re] = P("reactQueryDevtoolsActiveQueryHash", ""), he = o.useMemo(() => {
    const I = w.getAll();
    if (G === 0)
      return [];
    const S = b ? I.filter((B) => In(B.queryHash, b).passed) : [...I];
    return V ? S.sort((B, oe) => V(B, oe) * A) : S;
  }, [A, V, b, G, w]), [H, de] = o.useState(!1);
  return /* @__PURE__ */ o.createElement(vt, {
    theme: h
  }, /* @__PURE__ */ o.createElement(gr, Q({
    ref: n,
    className: "ReactQueryDevtoolsPanel",
    "aria-label": "React Query Devtools Panel",
    id: "ReactQueryDevtoolsPanel"
  }, c, {
    style: {
      height: ce,
      position: "relative",
      ...c.style
    }
  }), /* @__PURE__ */ o.createElement("style", {
    nonce: a,
    dangerouslySetInnerHTML: {
      __html: `
            .ReactQueryDevtoolsPanel * {
              scrollbar-color: ` + h.backgroundAlt + " " + h.gray + `;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar, .ReactQueryDevtoolsPanel scrollbar {
              width: 1em;
              height: 1em;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar-track, .ReactQueryDevtoolsPanel scrollbar-track {
              background: ` + h.backgroundAlt + `;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar-thumb, .ReactQueryDevtoolsPanel scrollbar-thumb {
              background: ` + h.gray + `;
              border-radius: .5em;
              border: 3px solid ` + h.backgroundAlt + `;
            }
          `
    }
  }), /* @__PURE__ */ o.createElement("div", {
    style: mr(m),
    onMouseDown: s
  }), r && /* @__PURE__ */ o.createElement("div", {
    style: {
      flex: "1 1 500px",
      minHeight: "40%",
      maxHeight: "100%",
      overflow: "auto",
      borderRight: "1px solid " + h.grayAlt,
      display: "flex",
      flexDirection: "column"
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em",
      background: h.backgroundAlt,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /* @__PURE__ */ o.createElement("button", {
    type: "button",
    "aria-label": "Close React Query Devtools",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "true",
    onClick: () => l(!1),
    style: {
      display: "inline-flex",
      background: "none",
      border: 0,
      padding: 0,
      marginRight: ".5em",
      cursor: "pointer"
    }
  }, /* @__PURE__ */ o.createElement(St, {
    "aria-hidden": !0
  }), /* @__PURE__ */ o.createElement(ke, {
    text: "Close React Query Devtools"
  })), /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: ".5em"
    }
  }, /* @__PURE__ */ o.createElement(Xr, {
    queryCache: w
  }), m && u ? /* @__PURE__ */ o.createElement(Ve, {
    "aria-label": "Panel position",
    value: m,
    style: {
      marginInlineStart: ".5em"
    },
    onChange: (I) => u(I.target.value)
  }, /* @__PURE__ */ o.createElement("option", {
    value: "left"
  }, "Left"), /* @__PURE__ */ o.createElement("option", {
    value: "right"
  }, "Right"), /* @__PURE__ */ o.createElement("option", {
    value: "top"
  }, "Top"), /* @__PURE__ */ o.createElement("option", {
    value: "bottom"
  }, "Bottom")) : null), /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "0.5em"
    }
  }, /* @__PURE__ */ o.createElement(hr, {
    placeholder: "Filter",
    "aria-label": "Filter by queryhash",
    value: b ?? "",
    onChange: (I) => O(I.target.value),
    onKeyDown: (I) => {
      I.key === "Escape" && O("");
    },
    style: {
      flex: "1",
      width: "100%"
    }
  }), /* @__PURE__ */ o.createElement(Ve, {
    "aria-label": "Sort queries",
    value: x,
    onChange: (I) => v(I.target.value),
    style: {
      flex: "1",
      minWidth: 75,
      marginRight: ".5em"
    }
  }, Object.keys(Ie).map((I) => /* @__PURE__ */ o.createElement("option", {
    key: I,
    value: I
  }, "Sort by ", I))), /* @__PURE__ */ o.createElement(_, {
    type: "button",
    onClick: () => k((I) => I * -1),
    style: {
      padding: ".3em .4em",
      marginRight: ".5em"
    }
  }, A === 1 ? "⬆ Asc" : "⬇ Desc"), /* @__PURE__ */ o.createElement(_, {
    title: "Clear cache",
    "aria-label": "Clear cache",
    type: "button",
    onClick: () => w.clear(),
    style: {
      padding: ".3em .4em",
      marginRight: ".5em"
    }
  }, "Clear"), /* @__PURE__ */ o.createElement(_, {
    type: "button",
    onClick: () => {
      H ? (Ne.setOnline(void 0), de(!1), window.dispatchEvent(new Event("online"))) : (Ne.setOnline(!1), de(!0));
    },
    "aria-label": H ? "Restore offline mock" : "Mock offline behavior",
    title: H ? "Restore offline mock" : "Mock offline behavior",
    style: {
      padding: "0",
      height: "2em"
    }
  }, /* @__PURE__ */ o.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2em",
    height: "2em",
    viewBox: "0 0 24 24",
    stroke: H ? h.danger : "currentColor",
    fill: "none"
  }, H ? /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "12",
    y1: "18",
    x2: "12.01",
    y2: "18"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "3",
    y1: "3",
    x2: "21",
    y2: "21"
  })) : /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "12",
    y1: "18",
    x2: "12.01",
    y2: "18"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M6.343 12.343a8 8 0 0 1 11.314 0"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
  }))), /* @__PURE__ */ o.createElement(ke, {
    text: H ? "Restore offline mock" : "Mock offline behavior"
  }))))), /* @__PURE__ */ o.createElement("div", {
    style: {
      overflowY: "auto",
      flex: "1"
    }
  }, he.map((I) => /* @__PURE__ */ o.createElement(Ot, {
    queryKey: I.queryKey,
    activeQueryHash: T,
    setActiveQueryHash: re,
    key: I.queryHash,
    queryCache: w
  })))), T && r ? /* @__PURE__ */ o.createElement(Br, {
    activeQueryHash: T,
    queryCache: w,
    queryClient: E,
    errorTypes: g
  }) : null, p ? /* @__PURE__ */ o.createElement(_, Q({
    type: "button",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "true"
  }, y, {
    style: {
      position: "absolute",
      zIndex: 99999,
      margin: ".5em",
      bottom: 0,
      left: 0,
      ...y.style
    },
    onClick: (I) => {
      l(!1), d == null || d(I);
    }
  }), "Close") : null));
}), Br = ({
  queryCache: e,
  activeQueryHash: t,
  queryClient: n,
  errorTypes: r
}) => {
  var a, l;
  const i = Z(e, () => e.getAll().find((d) => d.queryHash === t)), s = Z(e, () => {
    var d;
    return (d = e.getAll().find((y) => y.queryHash === t)) == null ? void 0 : d.state;
  }), u = (a = Z(e, () => {
    var d;
    return (d = e.getAll().find((y) => y.queryHash === t)) == null ? void 0 : d.isStale();
  })) != null ? a : !1, p = (l = Z(e, () => {
    var d;
    return (d = e.getAll().find((y) => y.queryHash === t)) == null ? void 0 : d.getObserversCount();
  })) != null ? l : 0, m = () => {
    const d = i == null ? void 0 : i.fetch();
    d == null || d.catch(_r);
  }, f = Qt(() => {
    if (i && s != null && s.error) {
      const d = r.find((y) => {
        var E;
        return y.initializer(i).toString() === ((E = s.error) == null ? void 0 : E.toString());
      });
      return d == null ? void 0 : d.name;
    }
  }, [i, s == null ? void 0 : s.error, r]);
  if (!i || !s)
    return null;
  const g = (d) => {
    var y;
    const E = (y = d == null ? void 0 : d.initializer(i)) != null ? y : new Error("Unknown error from devtools"), w = i.options;
    i.setState({
      status: "error",
      error: E,
      fetchMeta: {
        ...i.state.fetchMeta,
        __previousQueryOptions: w
      }
    });
  }, c = () => {
    i.fetch(i.state.fetchMeta.__previousQueryOptions, {
      // Make sure this fetch will cancel the previous one
      cancelRefetch: !0
    });
  };
  return /* @__PURE__ */ o.createElement(yr, null, /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em",
      background: h.backgroundAlt,
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Query Details"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      marginBottom: ".5em",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between"
    }
  }, /* @__PURE__ */ o.createElement(F, {
    style: {
      lineHeight: "1.8em"
    }
  }, /* @__PURE__ */ o.createElement("pre", {
    style: {
      margin: 0,
      padding: 0,
      overflow: "auto"
    }
  }, It(i.queryKey, !0))), /* @__PURE__ */ o.createElement("span", {
    style: {
      padding: "0.3em .6em",
      borderRadius: "0.4em",
      fontWeight: "bold",
      textShadow: "0 2px 10px black",
      background: Ct({
        queryState: s,
        isStale: u,
        observerCount: p,
        theme: h
      }),
      flexShrink: 0
    }
  }, ee(i))), /* @__PURE__ */ o.createElement("div", {
    style: {
      marginBottom: ".5em",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, "Observers: ", /* @__PURE__ */ o.createElement(F, null, p)), /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, "Last Updated:", " ", /* @__PURE__ */ o.createElement(F, null, new Date(s.dataUpdatedAt).toLocaleTimeString()))), /* @__PURE__ */ o.createElement("div", {
    style: {
      background: h.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Actions"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: "0.5em",
      display: "flex",
      flexWrap: "wrap",
      gap: "0.5em",
      alignItems: "flex-end"
    }
  }, /* @__PURE__ */ o.createElement(_, {
    type: "button",
    onClick: m,
    disabled: s.fetchStatus === "fetching",
    style: {
      background: h.active
    }
  }, "Refetch"), " ", /* @__PURE__ */ o.createElement(_, {
    type: "button",
    onClick: () => n.invalidateQueries(i),
    style: {
      background: h.warning,
      color: h.inputTextColor
    }
  }, "Invalidate"), " ", /* @__PURE__ */ o.createElement(_, {
    type: "button",
    onClick: () => n.resetQueries(i),
    style: {
      background: h.gray
    }
  }, "Reset"), " ", /* @__PURE__ */ o.createElement(_, {
    type: "button",
    onClick: () => n.removeQueries(i),
    style: {
      background: h.danger
    }
  }, "Remove"), " ", /* @__PURE__ */ o.createElement(_, {
    type: "button",
    onClick: () => {
      var d;
      if (!(i.state.fetchStatus === "fetching" && typeof ((d = i.state.fetchMeta) == null ? void 0 : d.__previousQueryOptions) > "u"))
        if (i.state.data === void 0)
          c();
        else {
          const y = i.options;
          i.fetch({
            ...y,
            queryFn: () => new Promise(() => {
            }),
            cacheTime: -1
          }), i.setState({
            data: void 0,
            status: "loading",
            fetchMeta: {
              ...i.state.fetchMeta,
              __previousQueryOptions: y
            }
          });
        }
    },
    style: {
      background: h.paused
    }
  }, i.state.status === "loading" ? "Restore" : "Trigger", " ", "loading"), " ", r.length === 0 || i.state.status === "error" ? /* @__PURE__ */ o.createElement(_, {
    type: "button",
    onClick: () => {
      i.state.error ? n.resetQueries(i) : g();
    },
    style: {
      background: h.danger
    }
  }, i.state.status === "error" ? "Restore" : "Trigger", " error") : /* @__PURE__ */ o.createElement("label", null, "Trigger error:", /* @__PURE__ */ o.createElement(Ve, {
    value: f ?? "",
    style: {
      marginInlineStart: ".5em"
    },
    onChange: (d) => {
      const y = r.find((E) => E.name === d.target.value);
      g(y);
    }
  }, /* @__PURE__ */ o.createElement("option", {
    key: "",
    value: ""
  }), r.map((d) => /* @__PURE__ */ o.createElement("option", {
    key: d.name,
    value: d.name
  }, d.name))))), /* @__PURE__ */ o.createElement("div", {
    style: {
      background: h.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Data Explorer"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ o.createElement(Be, {
    label: "Data",
    value: s.data,
    defaultExpanded: {},
    copyable: !0
  })), /* @__PURE__ */ o.createElement("div", {
    style: {
      background: h.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Query Explorer"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ o.createElement(Be, {
    label: "Query",
    value: i,
    defaultExpanded: {
      queryKey: !0
    }
  })));
}, Xr = ({
  queryCache: e
}) => {
  const t = Z(e, () => e.getAll().filter((i) => ee(i) === "fresh").length), n = Z(e, () => e.getAll().filter((i) => ee(i) === "fetching").length), r = Z(e, () => e.getAll().filter((i) => ee(i) === "paused").length), a = Z(e, () => e.getAll().filter((i) => ee(i) === "stale").length), l = Z(e, () => e.getAll().filter((i) => ee(i) === "inactive").length);
  return /* @__PURE__ */ o.createElement(br, null, /* @__PURE__ */ o.createElement(ae, {
    style: {
      background: h.success,
      opacity: t ? 1 : 0.3
    }
  }, "fresh ", /* @__PURE__ */ o.createElement(F, null, "(", t, ")")), " ", /* @__PURE__ */ o.createElement(ae, {
    style: {
      background: h.active,
      opacity: n ? 1 : 0.3
    }
  }, "fetching ", /* @__PURE__ */ o.createElement(F, null, "(", n, ")")), " ", /* @__PURE__ */ o.createElement(ae, {
    style: {
      background: h.paused,
      opacity: r ? 1 : 0.3
    }
  }, "paused ", /* @__PURE__ */ o.createElement(F, null, "(", r, ")")), " ", /* @__PURE__ */ o.createElement(ae, {
    style: {
      background: h.warning,
      color: "black",
      textShadow: "0",
      opacity: a ? 1 : 0.3
    }
  }, "stale ", /* @__PURE__ */ o.createElement(F, null, "(", a, ")")), " ", /* @__PURE__ */ o.createElement(ae, {
    style: {
      background: h.gray,
      opacity: l ? 1 : 0.3
    }
  }, "inactive ", /* @__PURE__ */ o.createElement(F, null, "(", l, ")")));
}, Ot = /* @__PURE__ */ o.memo(({
  queryKey: e,
  setActiveQueryHash: t,
  activeQueryHash: n,
  queryCache: r
}) => {
  var a, l, i, s;
  const u = (a = Z(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.queryHash;
  })) != null ? a : "", p = Z(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.state;
  }), m = (l = Z(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.isStale();
  })) != null ? l : !1, f = (i = Z(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.isDisabled();
  })) != null ? i : !1, g = (s = Z(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.getObserversCount();
  })) != null ? s : 0;
  return p ? /* @__PURE__ */ o.createElement("div", {
    role: "button",
    "aria-label": "Open query details for " + u,
    onClick: () => t(n === u ? "" : u),
    style: {
      display: "flex",
      borderBottom: "solid 1px " + h.grayAlt,
      cursor: "pointer",
      background: u === n ? "rgba(255,255,255,.1)" : void 0
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      flex: "0 0 auto",
      width: "2em",
      height: "2em",
      background: Ct({
        queryState: p,
        isStale: m,
        observerCount: g,
        theme: h
      }),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      textShadow: m ? "0" : "0 0 10px black",
      color: m ? "black" : "white"
    }
  }, g), f ? /* @__PURE__ */ o.createElement("div", {
    style: {
      flex: "0 0 auto",
      height: "2em",
      background: h.gray,
      display: "flex",
      alignItems: "center",
      fontWeight: "bold",
      padding: "0 0.5em"
    }
  }, "disabled") : null, /* @__PURE__ */ o.createElement(F, {
    style: {
      padding: ".5em"
    }
  }, "" + u)) : null;
});
Ot.displayName = "QueryRow";
function _r() {
}
const Nr = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : kr;
process.env.NODE_ENV;
const Tr = {
  origins: !0,
  priority: !0,
  timeout: 2e3,
  throttle: 1,
  limit: 2,
  // 동시에 최대 2개 URL만 prefetch
  ignores: [
    // API 엔드포인트 무시
    /\/api\//,
    // 파일 다운로드 무시
    /\.(zip|pdf|doc|docx|xls|xlsx|ppt|pptx)$/i,
    // noprefetch 속성이 있는 링크 무시
    (e, t) => (t == null ? void 0 : t.hasAttribute("noprefetch")) ?? !1,
    // 해시가 포함된 URL 무시 (SPA 라우팅)
    (e) => e.includes("#"),
    // 해당 2개 URL만 허용(그 외는 모두 무시)
    (e) => {
      try {
        const t = new URL(e, window.location.origin), n = `${t.origin}${t.pathname}`;
        return !(/* @__PURE__ */ new Set()).has(n);
      } catch {
        return !0;
      }
    }
  ]
};
function Hr() {
  return Tr;
}
const Dr = qe({
  containerId: "MVM7ZHX",
  customScriptSrc: "https://www.inflearn.com/mvm7zhx/s.js"
}), Yr = Object.assign({}, qe({
  containerId: "58GKPFHR",
  dataLayerName: "commonDataLayer",
  customScriptSrc: "https://www.inflearn.com/58gkpfhr/s.js"
}), {
  name: "common"
}), Fr = new Yt({
  defaultOptions: {
    queries: {
      retry: 0,
      suspense: !0,
      useErrorBoundary: !0,
      refetchOnWindowFocus: !1
    },
    mutations: {
      useErrorBoundary: !0
    }
  },
  logger: {
    log: console.log,
    error: console.log,
    warn: console.log
  }
});
function Wo({
  children: e,
  analytics: t,
  disableAnalyticsPlugins: n = !1,
  queryClient: r = Fr,
  navigate: a = Gt,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  withNormalizeCSS: l,
  quicklinkConfig: i = Hr()
}) {
  const s = Mt() ? ln(window.location.pathname) : void 0, [u] = zt(() => t || wt({
    app: "inflearn-monolith",
    plugins: n ? [] : [Dr, Yr]
  })), p = t ?? u;
  return tt(function() {
    (async () => {
      await dn(i);
    })().catch((g) => {
      console.error("Failed to initialize quicklink:", g);
    });
  }, [i]), /* @__PURE__ */ C(Rt, { navigate: a, children: /* @__PURE__ */ J(Xt, { cdnLink: Jt, lang: s, children: [
    /* @__PURE__ */ C(_t, {}),
    /* @__PURE__ */ J(Ft, { client: r, children: [
      /* @__PURE__ */ C(kt, { styles: [Ut, cn, process.env.NODE_ENV === "production" ? "" : ";label:AppShellProvider;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"] }),
      /* @__PURE__ */ C(Bt, { analytics: p, children: e }),
      nt !== "production" && /* @__PURE__ */ C(Nr, { initialIsOpen: !1 })
    ] })
  ] }) });
}
function Qr({
  children: e
}) {
  const t = fn(jt, {
    pollingIntervalMillis: 3e4,
    exposureEventDedupIntervalMillis: 1e3,
    autoOpenDevTool: nt !== "production",
    eventUrl: "https://gt.inflearn.com/hk-event",
    sdkUrl: "https://gt.inflearn.com/hk-sdk"
  }), n = Kt.get("deviceId"), r = n ? String(n) : void 0;
  return tt(() => {
    !t || !r || t.setDeviceId(r);
  }, [r, t]), /* @__PURE__ */ C(pn, { hackleClient: t, supportSSR: !0, children: e });
}
const zr = /^\/(en|ja|vi)(?=\/|$)/, Pr = [/^\/verify\/phone(\/|$)/, /^\/signin(\/|$)/, /^\/signup(\/|$)/, /^\/signout(\/|$)/, /^\/terms-agreement(\/|$)/, /^\/policy(\/|$)/, /^\/faq(\/|$)/, /^\/channeltalk(\/|$)/, /^\/my\/settings\/account(\/|$)/, /^\/user\/hello(\/|$)/, /^\/user\/signup-social(\/|$)/, /^\/challenge\/[^/]+\/attendance(-qr)?(\/|$)/], Mr = (e) => {
  const t = e.replace(zr, "") || "/";
  return Pr.some((n) => n.test(t));
}, Jr = (e) => !Te(e) && Te(e.phone) && !en(e) && !e.isInstructor && e.hasAnyVoucher === !1, Ke = () => {
  window.location.href = tn.stringifyUrl({
    url: nn.VERIFY_PHONE,
    query: {
      referUrl: window.location.href,
      spot: "app-shell"
    }
  });
};
function Ur() {
  const {
    t: e
  } = qt(), t = $e(), {
    isPhoneVerificationSignupFeatureOn: n
  } = sn(), {
    data: r
  } = $t(), a = t && n && Jr(r) && !Mr(window.location.pathname);
  return /* @__PURE__ */ J(z.Root, { opened: a, onClose: Ke, closeOnClickOutside: !1, children: [
    /* @__PURE__ */ C(z.Overlay, {}),
    /* @__PURE__ */ J(z.Content, { children: [
      /* @__PURE__ */ J(z.Header, { children: [
        /* @__PURE__ */ C(z.Title, { children: e("phone_verification.required_modal.title") }),
        /* @__PURE__ */ C(z.CloseButton, {})
      ] }),
      /* @__PURE__ */ C(z.Body, { children: /* @__PURE__ */ C(Nt, { children: e("phone_verification.required_modal.description") }) }),
      /* @__PURE__ */ C(z.Footer, { children: /* @__PURE__ */ C(Tt, { color: "infgreen", fullWidth: !0, onClick: Ke, children: e("phone_verification.required_modal.verify_button") }) })
    ] })
  ] });
}
function jr({
  header: e,
  footer: t,
  children: n,
  disableBottomNavigation: r,
  isShowingLoginNeededNotification: a = !1,
  showChanneltalk: l = !1,
  showMoveTop: i = !1,
  isAntMan: s = !1
}) {
  const u = $e();
  return /* @__PURE__ */ J(rn, { isShowing: a ?? !1, children: [
    /* @__PURE__ */ C(Zt, {}),
    /* @__PURE__ */ C(Ur, {}),
    /* @__PURE__ */ J(Wt, { children: [
      i ? /* @__PURE__ */ C(gn, { isAntMan: s ?? !1 }) : null,
      u && /* @__PURE__ */ C(Lt, {}),
      /* @__PURE__ */ J(Vt, { children: [
        e,
        /* @__PURE__ */ C("div", { id: on.CHILDREN_WRAPPER, style: {
          backgroundColor: "white"
        }, children: n }),
        t && Pt(t, {
          hasBottomNavigation: !r
        }),
        /* @__PURE__ */ C(an, { children: r ? null : /* @__PURE__ */ C(yn, {}) }),
        l ? /* @__PURE__ */ C(mn, {}) : null,
        /* @__PURE__ */ C(bn, {})
      ] })
    ] })
  ] });
}
function Lo(e) {
  return /* @__PURE__ */ C(un, { children: /* @__PURE__ */ C(Qr, { children: /* @__PURE__ */ C(jr, { ...e }) }) });
}
export {
  Lo as AppShell,
  Wo as AppShellProvider,
  Bo as Header
};
